import { Injectable, signal } from '@angular/core'
import { OcBreadcrumbItem } from 'otimus-library'

@Injectable({ providedIn: 'root' })
export class BreadcrumbService {
  readonly path = signal<OcBreadcrumbItem[]>([])

  setPath(path: OcBreadcrumbItem[]): void {
    this.path.set(path)
  }

  appendPath(slug: OcBreadcrumbItem): void {
    this.path.update((current) => [...current, slug])
  }

  clear(): void {
    this.path.set([])
  }
}
